import React, { useState, useEffect, useCallback } from 'react';
import { Link, Transition } from 'components';
import { config, cookies, encrypt } from 'helpers';
import css from './cookie-popup.scss';

export function CookiePopup(props) {
  const [ visible, setVisible ] = useState();

  useEffect(() => {
    if (!cookies.get('cookies-use-accepted')) {
      const timeout = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timeout);
    }
  }, []);

  const accept = useCallback(() => {
    setVisible(false);
    cookies.set('cookies-use-accepted', '1', { expires: 365*10 });
  });

  return (
    <Transition in={visible} mountOnEnter unmountOnExit classNames={css.locals}>
      <div className={css.container}>
        By viewing this website you agree to our <Link onClick={accept} to="/privacy/">Privacy Policy</Link>
        <i className={`icon icon-close ${css.close}`} onClick={accept} />
      </div>
    </Transition>
  );
}
